import { styled } from "@mui/material";
import AcxButton from "components/UI/AcxButton";

const Suggestion = styled(AcxButton)(({ theme }) => ({
    paddingInline: theme.spacing(1.5),
    paddingBlock: theme.spacing(0.75),
    border: `1px solid ${theme.palette.gray[300]}`,
    color: theme.palette.gray[800],
    backgroundColor: theme.palette.white.main,
    borderRadius: "9999px",
    fontWeight: 600,
    height: "min-content",
    textWrap: "wrap",
    textAlign: "start",
    ":hover": {
        backgroundColor: theme.palette.gray[100],
    },
    ":disabled": {
        color: theme.palette.gray[800],
        backgroundColor: theme.palette.white.main,
        opacity: 0.5,
    },
    "& .MuiButton-startIcon": {
        marginRight: theme.spacing(0.75),
        color: theme.palette.gray[600],
    },
}));

Suggestion.defaultProps = {
    fullWidth: false,
    id: "kbo-suggested-response",
};

export { Suggestion };
